// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { translateFromPresentation } from "@sequentech/ui-core";
import { useCallback } from "react";
import { useGetOne } from "react-admin";
import { useTranslation } from "react-i18next";
/**
 * The default language a record's `presentation.language_conf` sets. Accepts
 * the record or its presentation.
 */
export var configuredLanguage = function (record) {
    var _a, _b, _c, _d;
    var owner = record;
    var code = (_c = (_b = (_a = owner === null || owner === void 0 ? void 0 : owner.presentation) === null || _a === void 0 ? void 0 : _a.language_conf) === null || _b === void 0 ? void 0 : _b.default_language_code) !== null && _c !== void 0 ? _c : (_d = owner === null || owner === void 0 ? void 0 : owner.language_conf) === null || _d === void 0 ? void 0 : _d.default_language_code;
    return typeof code === "string" && code ? code : undefined;
};
/**
 * Election events, elections, contests and candidates keep their names in
 * `presentation.i18n` (migration 1772358027729), so this renders a record's
 * name in the interface language, else in the record's default language, else
 * in English.
 */
export function usePresentationName() {
    var i18n = useTranslation().i18n;
    return useCallback(function (record) {
        var _a, _b;
        return (_b = (_a = translateFromPresentation(record, "name", i18n.language, {
            defaultLanguageCode: configuredLanguage(record),
        })) !== null && _a !== void 0 ? _a : translateFromPresentation(record, "name", "en")) !== null && _b !== void 0 ? _b : "";
    }, [i18n.language]);
}
/** The form source of a record's name in its default language. */
export var presentationNameSource = function (record) { var _a, _b; return "presentation.i18n.".concat(((_b = (_a = record === null || record === void 0 ? void 0 : record.presentation) === null || _a === void 0 ? void 0 : _a.language_conf) === null || _b === void 0 ? void 0 : _b.default_language_code) || "en", ".name"); };
/**
 * The default language a contest or candidate inherits: its election's, else
 * its event's, as the voting portal resolves it.
 */
export function useInheritedLanguage(record) {
    var _a, _b, _c;
    var electionId = (_a = record === null || record === void 0 ? void 0 : record.election_id) !== null && _a !== void 0 ? _a : "";
    var eventId = (_b = record === null || record === void 0 ? void 0 : record.election_event_id) !== null && _b !== void 0 ? _b : "";
    var election = useGetOne("sequent_backend_election", { id: electionId }, { enabled: Boolean(electionId) }).data;
    var event = useGetOne("sequent_backend_election_event", { id: eventId }, { enabled: Boolean(eventId) }).data;
    return (_c = configuredLanguage(election)) !== null && _c !== void 0 ? _c : configuredLanguage(event);
}
